export default "/images/vendor/flag-icon-css/flags/1x1/gu.svg?43b14205fd72b01599c76a79b4b81680";